/// <reference types="node" />
import { Document, Page, pdfjs } from 'react-pdf'

// workerSrc must be set in the SAME module that re-exports Document/Page so it is
// applied before any <Document> renders (avoids ESM order overwriting it).
// The worker file is copied into public/ by the postinstall script (see package.json).
// It is copied as .js, not .mjs: nginx has no mime.types entry for .mjs and would
// serve it as text/plain, which fails the browser's strict module MIME check.
// pdf.js always loads the worker with { type: 'module' }, so the extension is free.
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'

export { Document, Page, pdfjs }
